import React, { useState, useEffect } from 'react';
import { addLabelToExtraction } from '../api/quontxApi';

// The modal now receives the necessary IDs and the initial label
const AddLabelModal = ({ extractionId, etlConfigUuid, initialLabel, onClose, onLabelAdded }) => {
  // State is initialized with the existing label, if any
  const [label, setLabel] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Use useEffect to set the state when the initialLabel prop is ready
  useEffect(() => {
    setLabel(initialLabel || '');
  }, [initialLabel]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      // Call the updated API function with the correct parameters
      await addLabelToExtraction(extractionId, etlConfigUuid, label);
      onLabelAdded(); // Callback to refresh data in parent
      onClose();      // Close the modal
    } catch (err) {
      setError('Failed to set label. Please try again.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50">
      <div className="bg-qtx-darker p-8 rounded-lg shadow-xl w-full max-w-md">
        <h2 className="text-2xl font-bold mb-6 text-white">Set Extraction Label</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <label htmlFor="label" className="block text-qtx-light-gray text-sm font-bold mb-2">Label</label>
            <input
              type="text"
              id="label"
              value={label}
              onChange={(e) => setLabel(e.target.value)}
              className="w-full bg-qtx-dark border border-qtx-gray rounded py-2 px-3 text-white leading-tight focus:outline-none focus:ring-2 focus:ring-qtx-blue"
              placeholder="e.g., stable"
            />
          </div>
          {error && <p className="text-red-500 text-xs italic mb-4">{error}</p>}
          <div className="flex items-center justify-end space-x-4">
            <button type="button" onClick={onClose} className="text-qtx-light-gray font-bold py-2 px-4 rounded focus:outline-none">
              Cancel
            </button>
            <button type="submit" disabled={loading} className="bg-qtx-blue hover:bg-blue-600 text-white font-bold py-2 px-4 rounded focus:outline-none disabled:bg-qtx-gray">
              {loading ? 'Saving...' : 'Save Label'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddLabelModal;